import {EnvelopeIcon, PhoneIcon} from '@heroicons/react/20/solid'
import {transformImage} from "../../utils/StoryblokService";
import Head from "next/head";
import React from "react";
import EncryptedEmail from "../functional/EncryptedEmail";
import {triggerPhoneConversion} from "../../utils/Helpers";

export default function BlogHeader(props: any) {

    const profile = {
        name: 'Christoph Heike',
        avatar:
            '/images/ceo_inset.webp',

        backgroundImage: transformImage(props.blok.image.filename, "3600x512"),
    }

    return (
        <>
            <Head>
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(
                            {
                                "@context": "https://schema.org",
                                "@type": "NewsArticle",
                                "headline": props.blok.title,
                                "image": [
                                    transformImage(props.blok.image.filename, "1024x1024"),
                                ],
                                "datePublished": props.blok.date,
                                "author": [{
                                    "@type": "Person",
                                    "name": "Christoph Heike",
                                }]
                            }
                        )
                    }}/>

            </Head>


        <div className={""}>
            <div>
                <img className="h-32 w-full object-cover lg:h-64" src={profile.backgroundImage} alt=""/>
            </div>
            <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
                {props.blok.show_author &&
                    <div className="-mt-12 sm:-mt-16 sm:flex sm:items-end sm:space-x-5">

                        <div className="flex">
                            <img className="h-24 bg-white rounded-full ring-4 ring-white sm:h-32"
                                 src={profile.avatar}
                                 alt="Christoph Heike - Author"/>
                        </div>

                        <div
                            className="mt-6 sm:flex sm:min-w-0 sm:flex-1 sm:items-center sm:justify-end sm:space-x-6 sm:pb-1">

                            <div className="mt-6 min-w-0 flex-1 sm:hidden md:block">
                                <p className="truncate text-2xl font-bold text-gray-900">{profile.name}</p>
                            </div>


                            <div
                                className="mt-6 flex flex-col justify-stretch space-y-3 sm:flex-row sm:space-x-4 sm:space-y-0">
                                <button
                                    type="button"
                                    className="inline-flex justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                >
                                    <EnvelopeIcon className="-ml-0.5 mr-1.5 h-5 w-5 text-gray-400" aria-hidden="true"/>
                                    <EncryptedEmail type={"contact"} className={""}/>
                                </button>
                                <a
                                    type="button"
                                    onClick={() => triggerPhoneConversion()}
                                    href={"tel:+19495412305"}
                                    className="inline-flex justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                >
                                    <PhoneIcon className="-ml-0.5 mr-1.5 h-5 w-5 text-gray-400" aria-hidden="true"/>
                                    <span>Call</span>
                                </a>
                            </div>

                        </div>
                    </div>
                }
                <div className="mt-6 hidden min-w-0 flex-1 sm:block md:hidden">
                    <p className="truncate text-2xl font-bold text-gray-900">{profile.name}</p>
                </div>
            </div>

            <div className={" "}>
                <div className="mx-auto max-w-4xl my-12 px-6 lg:px-8">
                    <p className="text-base font-semibold leading-7 text-secondary">Blog Post</p>
                    <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                        {props.blok.title}
                    </h1>

                    <p className={'prose text-gray-600'}>
                        {props.blok.intro}
                    </p>
                </div>
            </div>
        </div>
        </>
    )
}

